import React, { useEffect, useState, useRef } from "react";
import useChatStore from "../../store/useChatStore";
import NormalQuestion from "../bizzieChat/NormalQuestion";
import OptionTypeResponse from "../bizzieChat/OptionTypeResponse";
import OptionTypeWithTitleResponse from "../bizzieChat/OptionTypeWithTitleResponse";
import UploadMessage from "../bizzieChat/UploadMessage";
import ChatHistoryBox from "../bizzieChat/ChatHistoryBox";
import UserTypedResponse from "../bizzieChat/UserResponeTyped";
import DocumentUploadQuestion from "../bizzieChat/DocumentUploadQuestion";
import MessageWithQuestion from "../bizzieChat/MessageWithQuestion";
import TypedResponse from "../bizzieChat/TypedResponse";
import UserUploadResponse from "../bizzieChat/UserResponseUpload";
import TypingIndicator from "../bizzieChat/TypingIndicator";
import UploadMultiMessage from "../bizzieChat/UploadMultiMessage";
import axios from "axios";
import { CREDIT_API_URL } from "../../constants"; // Ensure the correct API URL is imported

const ChatSection = () => {
    const chatContainerRef = useRef(null);
    const { customer, chatSessionId, loanId, chatHistory, addChatMessage, fetchChatHistory, currentStep, isGstCompleted,
        setCurrentStep, isPanCompleted, chatSessionStatus, kycType, isAadharCompleted } = useChatStore(); // Get logged-in user
    const [leadDetails, setLeadDetails] = useState(null);
    const panNumber = useChatStore((state) => state.panNumber);
    const setPanNumber = useChatStore((state) => state.setPanNumber);
    const [isPanUploaded, setIsPanUploaded] = useState(false); // Track if document is uploaded
    const [showTyping, setShowTyping] = useState(false); // Simulates bot thinking
    const aadharNumber = useChatStore((state) => state.aadharNumber);
    const setAadharNumber = useChatStore((state) => state.setAadharNumber);
    const [isAadharUploaded, setIsAadharUploaded] = useState(false);
    const gstNumber = useChatStore((state) => state.gstNumber);
    const setGstNumber = useChatStore((state) => state.setGstNumber);
    const [isGstUpload, setisGstUpload] = useState(false);
    const companypanNumber = useChatStore((state) => state.companypanNumber);
    const setCompanypanNumber = useChatStore((state) => state.setCompanypanNumber);
    const [isCompanyPanUploaded, setIsCompanyPanUploaded] = useState(false);
    const [isBankUploaded, setIsBankUploaded] = useState(false);
    const [isItrUploaded, setIsItrUploaded] = useState(false);
    // Determine whether user has explicitly submitted a PAN/Aadhar in this chat session
    const lastUserPanSubmission = chatHistory && Array.isArray(chatHistory)
        ? chatHistory.slice().reverse().find(m => (m.responseType === 'PAN') || (m.sentBy === 'user' && typeof m.text === 'string' && /PAN/i.test(m.text)))
        : null;
    const lastUserAadharSubmission = chatHistory && Array.isArray(chatHistory)
        ? chatHistory.slice().reverse().find(m => (m.responseType === 'Aadhar') || (m.sentBy === 'user' && typeof m.text === 'string' && /\b\d{12}\b/.test(m.text)))
        : null;
    // const [mobileNumber, setMobileNumber] = useState("");
    // const [showOtpModal, setShowOtpModal] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    const delay = async (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // ✅ Auto-Scroll to Bottom on New Messages
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
        // if (chatHistory.length === 0) {
        //     addChatMessage({ text: "Hey there! 👋 I'm Bizzie, your loan buddy!" });
        // }
        setTimeout(() => {
            if (chatHistory.length === 1) {
                // addChatMessage({ text: "An OTP has been sent to your mobile number. Please confirm to proceed." });
                initalStep();
            }
        }, 1000);
    }, [chatHistory]); // ✅ Runs every time chat updates

    // ✅ Handle Mobile Number Entry
    // const handleMobileNumber = (response) => {
    //     if (!/^\d{10}$/.test(response)) {
    //         alert("❌ Invalid phone number. It must be 10 digits.");
    //         return;
    //     }

    //     setMobileNumber(response);
    //     addChatMessage({ text: response }, "user");
    //     setShowOtpModal(true); // ✅ Show OTP Modal
    // };

    const initalStep = async () => {
        if (!leadDetails) return;
        await addChatMessage({ text: `You have applied for ₹${leadDetails.loanAmount || 0} under ${leadDetails.productType || ''}.` });
        setShowTyping(true);
        await createLoanRequest();
        await delay(1500);
        setShowTyping(false);
        await setCurrentStep("APPLICANT_TYPE");
        await addChatMessage({ text: "Please select how you're applying for the loan: as an Individual or a Company." });
    }
    // ✅ Handle OTP Confirmation
    const handleOtpConfirmation = async (response) => {
        setShowTyping(true);
        await delay(1500);
        setShowTyping(false);
        addChatMessage({ text: "OTP - " + response }, "user");
        if (response === "12345") {
            // ✅ Save Mobile Confirmation in Chat
            addChatMessage({
                text: `Mobile number confirmed: ${customer.mobile}`,
                responseType: "info",
                sentBy: "bot"
            });
            await delay(500);
            addChatMessage({ text: `You have applied for ₹${leadDetails.loanAmount} under ${leadDetails.productType}.` });
            setShowTyping(true);
            await delay(500);
            createLoanRequest();
            // ✅ Move to Next Step (KYC Collection)
            await delay(500);
            addChatMessage({ text: "Please select how you're applying for the loan: as an Individual or a Company." });
            await delay(1000);
            setCurrentStep("APPLICANT_TYPE");
        } else {
            addChatMessage({
                text: `❌ Incorrect OTP. Please try again`,
                responseType: "info",
                sentBy: "bot"
            });
        }
    };

    // ✅ Fetch Lead Details (Only Allow COMMERCIAL VEHICLE LOAN)
    useEffect(() => {
        if (customer && customer.chatSessionId && customer.loanRequestId) {
            setLeadDetails(customer);
            useChatStore.setState({ chatSessionId: customer.chatSessionId, loanId: customer.loanRequestId });
            fetchChatHistory(customer.chatSessionId);
        }
    }, [customer]);

    // ✅ Handle User's Confirmation to Proceed
    const handleProceed = (response) => {
        if (response === "Yes") {
            addChatMessage({ text: `You have applied for ₹${leadDetails.loanAmount} under ${leadDetails.productType}.` });
            addChatMessage({ text: response }, "user");
            setShowTyping(true);
            setTimeout(() => {
                setShowTyping(false);
                createLoanRequest();
            }, 2000);
        } else {
            // ✅ Ask for Loan Amount Again
            addChatMessage({ text: "no" }, "user");
            addChatMessage({ text: "How much funding are you seeking?" }, "bot");
            setShowTyping(true);
            setTimeout(() => {
                setShowTyping(false);
                setCurrentStep("LOAN_AMOUNT"); // ✅ Move to Loan Amount Input Step
            }, 1000); // ✅ Simulating a delay for bot response
            // setCurrentStep("END_CHAT");
        }
    };

    const handleApplicationTypeProceed = async (response) => {
        if (response === "Individual") {
            addChatMessage({ text: response, responseType: "selection" }, "user");
            addChatMessage({ text: "Selected Application Type: " + response });
            addChatMessage({ text: "Enter your PAN card number" });
            await setCurrentStep("KYC_START");
        } else if (response === "Company") {
            setShowTyping(true);
            await setCurrentStep("COMPANY_GST_START");
            await delay(1000);
            await addChatMessage({ text: response, responseType: "selection" }, "user");
            await addChatMessage({ text: "Selected Application Type: " + response });
            await addChatMessage({ text: "Enter company's GST number" });
            setShowTyping(false);
            await fetchChatHistory(chatSessionId);
        }
    };

    const handleLoanAmountChange = async (response) => {
        // ✅ Extract only numeric values from the input
        const extractedAmount = response.replace(/[^0-9]/g, ""); // Remove non-numeric characters
        const newLoanAmount = parseInt(extractedAmount, 10);

        // ✅ Validate Loan Amount
        if (isNaN(newLoanAmount) || newLoanAmount < 50000) {
            alert("❌ Please enter a valid loan amount (₹50,000 or more).");
            return;
        }

        // ✅ Update Loan Amount in Chat
        addChatMessage({ text: `Requested Loan Amount: ₹${newLoanAmount.toLocaleString()}` }, "user");


        setShowTyping(true);
        setTimeout(() => {
            setShowTyping(false);
            addChatMessage({ text: "Loan amount updated successfully! ✅", sentBy: "Bot" });
        }, 1000);

        // ✅ Update Loan Amount in `leadDetails` (Update UI Instantly)
        setLeadDetails((prevDetails) => ({
            ...prevDetails,
            loanAmount: newLoanAmount, // ✅ Instantly update state
        }));

        try {
            // ✅ Ask "Would you like to proceed?" Again
            setShowTyping(true);
            setTimeout(() => {
                setShowTyping(false);
                setCurrentStep("WELCOME"); // ✅ Move back to Proceed Confirmation Step
            }, 1500);
        } catch (error) {
            console.error("❌ Error updating loan amount:", error);
        }
    };

    // ✅ Create Loan Request when User Confirms
    const createLoanRequest = async () => {
        if (loanId) return; // ✅ Prevent duplicate loan requests
        axios.post(`${CREDIT_API_URL}loans/create-loan`, {
            customerId: customer.customerId,
            productType: leadDetails.productType,
            loanAmount: leadDetails.loanAmount,
        })
            .then((res) => {
                const newLoanId = res.data.data.id; // ✅ Get the new loan request ID

                console.log("✅ Loan request created:", newLoanId);

                // ✅ Save Loan ID in Zustand
                useChatStore.setState({ loanId: newLoanId });

                // ✅ Update Chat Session with Loan ID
                axios.put(`${CREDIT_API_URL}chat-sessions/${chatSessionId}`, {
                    loanRequestId: newLoanId,
                })
                    .then(() => {
                        console.log("✅ Chat session updated with loanRequestId:", newLoanId);
                    })
                    .catch((error) => {
                        console.error("❌ Error updating chat session:", error);
                    });

                setShowTyping(false);
                setTimeout(() => {
                    // ✅ Save success message in chat history
                    addChatMessage({ text: "Loan request created successfully!" });
                    // ✅ Move to Next Step (KYC Collection)
                    setCurrentStep("APPLICANT_TYPE");
                }, 100);

            })
            .catch((error) => {
                console.error("❌ Error creating loan request:", error);
            });
    };

    // Handle PAN Number Submission
    const handlePanNumber = async (response) => {
        await addChatMessage({ text: `PAN Number: ${response}`, responseType: "PAN", createdAt: new Date().toISOString() }, "user"); // Save user response
        setShowTyping(true);
        await delay(100);
        setPanNumber(response); // Store the PAN number
        setShowTyping(false);
        await addChatMessage({ text: "PAN card number added ✅", createdAt: new Date().toISOString() }); // Bot confirmation
        // ✅ First, Add Document Request Message
        await addChatMessage({
            text: "Upload a copy of your PAN card.",
            responseType: "upload_request",
            createdAt: new Date().toISOString()
        }, "bot");
    };

    // Handle PAN Card Upload
    const handlePanUpload = async (fileName, file) => {
        setIsPanUploaded(true); // Track document upload
        await addChatMessage({ text: `PAN card`, responseType: "upload_pan", attachmentPath: fileName, createdAt: new Date().toISOString() }, "user");
        setShowTyping(true);

        // ✅ Send PAN Number & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "PAN");
        formData.append("documentValue", panNumber);
        formData.append("document", file); // ✅ Upload file as multipart

        try {
            const response = await axios.post(`${CREDIT_API_URL}kyc`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log("PAN KYC submitted successfully!");

            // Link KYC to Loan
            if (response.data && response.data.data.id) {
                linkKycToLoan(loanId, response.data.data.id);
                await addChatMessage({ text: `PAN card document uploaded successfully! ✅`, responseType: "normal" }, "bot", response.data.data.id);
                await delay(1500); 
                setShowTyping(false);
                // Advance UI immediately so user sees next prompt while backend syncs
                if (kycType === "Company") {
                    setCurrentStep("COMPANY_GST_START");
                } else {
                    setCurrentStep("AADHAR_START");
                }
                // Then refresh chat history and run step handlers (may be slower)
                await fetchChatHistory(chatSessionId);
                await handlesteps();
            }
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    const linkKycToLoan = async (loanRequestId, kycDocumentId) => {
        if (!loanRequestId || !kycDocumentId) {
            console.error("❌ Missing loanRequestId or kycDocumentId");
            return;
        }

        try {
            await axios.post(`${CREDIT_API_URL}kyc/link/loan`, {
                loanRequestId,
                kycDocumentId
            });

            console.log(`✅ KYC Document ${kycDocumentId} linked to Loan ${loanRequestId}`);
        } catch (error) {
            console.error("❌ Error linking KYC to Loan:", error);
        }
    };

    // ✅ Handle Aadhar Number Submission
    const handleAadharNumber = async (response) => {
        setAadharNumber(response);
        setShowTyping(true);
        await addChatMessage({ text: `Aadhar Number: ${response}`, responseType: "Aadhar", createdAt: new Date().toISOString() }, "user");
        await delay(500);
        setShowTyping(false);
        await addChatMessage({ text: "Aadhar card number added ✅", createdAt: new Date().toISOString() });
        await delay(500);
        // ✅ First, Add Document Request Message
        await addChatMessage({
            text: "Upload a copy of your Aadhar card.",
            responseType: "upload_request",
            createdAt: new Date().toISOString()
        }, "bot");
    };

    // ✅ Handle Aadhar Upload
    const handleAadharUpload = async (fileName, file) => {
        setIsAadharUploaded(true);
        setShowTyping(true);

        // ✅ Send Aadhar Number & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "Aadhar");
        formData.append("documentValue", aadharNumber);
        formData.append("document", file);

        try {
            const response = await axios.post(`${CREDIT_API_URL}kyc`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log("✅ Aadhar KYC submitted successfully!");

            // ✅ Link KYC to Loan
            if (response.data && response.data.data.id) {
                await linkKycToLoan(loanId, response.data.data.id);
                await addChatMessage({ text: `Aadhar card`, responseType: "upload_aadhar", attachmentPath: fileName, createdAt: new Date().toISOString() }, "user");
                await addChatMessage({ text: "Aadhar card document uploaded successfully! ✅", responseType: "normal", createdAt: new Date().toISOString() });
            }
            await delay(1000);
            setShowTyping(false);
            setCurrentStep("BANK_UPLOAD"); // ✅ Move to Next KYC Step
            // ✅ First, Add Document Request Message
            await addChatMessage({
                text: "Upload a copy of your Bank Statement.",
                responseType: "upload_request",
                createdAt: new Date().toISOString()
            }, "bot");
        } catch (error) {
            console.error("❌ Error submitting Aadhar KYC:", error);
        }
    };

    // ✅ Handle Company GST Number Submission
    const handleCompanyGstNumber = (response) => {
        setGstNumber(response);
        addChatMessage({ text: `GST number: ${response}`, responseType: "GST" }, "user");

        setShowTyping(true);
        setTimeout(() => {
            setShowTyping(false);
            addChatMessage({ text: "GST number added ✅" });

            // ✅ First, Add Document Request Message
            addChatMessage({
                text: "Upload a copy of company GST",
                responseType: "upload_request"
            }, "bot");

        }, 1000);
    };

    // ✅ Handle Company Gst Upload
    const handleCompanyGstUpload = async (fileName, file) => {
        setisGstUpload(true);
        setShowTyping(true);

        // ✅ Send Company Gst & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "GSTC");
        formData.append("documentValue", gstNumber);
        formData.append("document", file);
        try {
            const response = await axios.post(`${CREDIT_API_URL}kyc`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log("✅ GST certificate KYC submitted successfully!");

            // ✅ Link KYC to Loan
            if (response.data && response.data.data.id) {
                await linkKycToLoan(loanId, response.data.data.id);
                setShowTyping(false);
                addChatMessage({ text: `GST certificate`, responseType: "upload_gst" }, "user");
                addChatMessage({ text: "GST certificate uploaded successfully! ✅" });
            }
            addChatMessage({ text: "Enter your Company PAN number" });
            setCurrentStep("COMPNAY_PAN_START"); // ✅ Move to Next KYC Step
        } catch (error) {
            console.error("❌ Error submitting Company Gst KYC:", error);
        }
    };

    // ✅ Handle Company PAN Number Submission
    const handleCompanyPanNumber = (response) => {
        setCompanypanNumber(response);
        addChatMessage({ text: `Company PAN Number: ${response}`, responseType: "COMP_PAN" }, "user"); // Save user response

        setShowTyping(true);
        setTimeout(() => {
            setPanNumber(response); // Store the PAN number
            setShowTyping(false);
            addChatMessage({ text: "Company PAN card number added ✅" }); // Bot confirmation

            // ✅ First, Add Document Request Message
            addChatMessage({
                text: "Upload a copy of your Company PAN card.",
                responseType: "upload_request"
            }, "bot");

        }, 1000);
    };

    // ✅ Handle Company PAN Card Upload
    const handleCompanyPanUpload = async (fileName, file) => {
        setIsCompanyPanUploaded(true); // ✅ Track document upload
        setShowTyping(true);

        // ✅ Send PAN Number & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "CPAN");
        formData.append("documentValue", companypanNumber);
        formData.append("document", file); // ✅ Upload file as multipart

        try {
            const response = await axios.post(`${CREDIT_API_URL}kyc`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log("✅ Company PAN KYC submitted successfully!");

            // ✅ Link KYC to Loan
            if (response.data && response.data.data.id) {
                linkKycToLoan(loanId, response.data.data.id);
                setShowTyping(false);
                addChatMessage({ text: `Company PAN card`, responseType: "upload_cmp_pan", attachmentPath: fileName }, "user", response.data.data.id);
                addChatMessage({ text: `Company PAN card document uploaded successfully! ✅`, responseType: "normal" }, "bot", response.data.data.id);
            }

            setTimeout(() => {
                addChatMessage({
                    text: "Upload last 6 months bank statement",
                    responseType: "upload_request"
                }, "bot");
                setCurrentStep("BANK_UPLOAD"); // ✅ Move to next KYC step
            }, 1000);
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    // ✅ Handle Bank Statement Upload
    const handleBankUpload = async (fileName, file) => {
        setIsBankUploaded(true);
        setShowTyping(true);

        // ✅ Send Bank Statement to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "BankStatement");
        formData.append("document", file);

        try {
            const response = await axios.post(`${CREDIT_API_URL}kyc`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log("✅ Bank Statement uploaded successfully!");

            // ✅ Link KYC to Loan
            if (response.data && response.data.data.id) {
                linkKycToLoan(loanId, response.data.data.id);
                setShowTyping(false);
                addChatMessage({ text: `Bank statement`, responseType: "upload_bank", attachmentPath: fileName }, "user");
                addChatMessage({ text: "Bank statement uploaded successfully! ✅" });
            }

            setShowTyping(true);
            await delay(1000);
            setShowTyping(false);
            // ✅ First, Add Document Request Message
            addChatMessage({
                text: "Upload a copy of your ITR Statement.",
                responseType: "upload_request"
            }, "bot");
            await delay(300);
            setCurrentStep("ITR_UPLOAD"); // ✅ Move to ITR Upload

        } catch (error) {
            console.error("❌ Error uploading Bank Statement:", error);
        }
    };

    // ✅ Handle ITR Upload
    const handleItrUpload = async (fileName, file) => {
        setIsItrUploaded(true);
        setShowTyping(true);

        // ✅ Send ITR to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "ITR");
        formData.append("document", file);

        try {
            const response = await axios.post(`${CREDIT_API_URL}kyc`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log("✅ ITR Statement uploaded successfully!");

            // ✅ Link KYC to Loan
            if (response.data && response.data.data.id) {
                linkKycToLoan(loanId, response.data.data.id);
                addChatMessage({ text: `ITR Statement`, responseType: "upload_itr", attachmentPath: fileName}, "user", response.data.data.id);
                addChatMessage({ text: `ITR statement uploaded successfully! ✅`, responseType: "normal" }, "bot", response.data.data.id);
            }

            // ✅ Close Chat Session
            await closeChatSession(chatSessionId);
            setShowTyping(true);
            setTimeout(() => {
                setShowTyping(false);
                setCurrentStep("THANK_YOU"); // ✅ Move to Thank You
                if (chatContainerRef.current) {
                    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                }
            }, 1500);
        } catch (error) {
            console.error("❌ Error uploading ITR:", error);
        }
    };

    const handleEditResponse = async (responseType) => {
        if (responseType === "selection") {
            setShowTyping(true);
            setCurrentStep("APPLICANT_TYPE_EDIT"); // ✅ Open Applicant Type Selection Again
            await delay(500);
            setShowTyping(false);
            addChatMessage({ text: "You've chosen to update your application type. Select a new option: Individual or Company." });
        } else if (responseType === "PAN") {
            setShowTyping(true);
            await delay(1000);
            setCurrentStep("EDIT_PAN"); // Switch UI to PAN Editing
            await delay(300);
            setShowTyping(false);
            addChatMessage({ text: "Updating PAN Number... ⏳" });
            setShowOverlay(true);
        } else if (responseType === "Aadhar") {
            setShowTyping(true);
            await delay(1000);
            setShowOverlay(true);
            setCurrentStep("EDIT_Aadhar"); // Switch UI to PAN Editing
            await delay(300);
            setShowTyping(false);
            addChatMessage({ text: "Updating Aadhar Number... ⏳" });
        } else if (responseType === "upload_pan") {
            setShowTyping(true);
            setShowOverlay(true);
            await delay(1000);
            setShowTyping(false);
            setCurrentStep("EDIT_PAN_UPLOAD");
            addChatMessage({ text: "Re-upload PAN document requested." });

        } else if (responseType === "upload_aadhar") {
            setShowTyping(true);
            setShowOverlay(true);
            await delay(1000);
            setShowTyping(false);
            setCurrentStep("EDIT_Aadhar_UPLOAD");
            addChatMessage({ text: "Re-upload Aadhar document requested." });

        } else if (responseType === "upload_bank") {
            setShowTyping(true);
            setShowOverlay(true);
            await delay(1000);
            setShowTyping(false);
            setCurrentStep("EDIT_BANK_UPLOAD");
            addChatMessage({ text: "Re-upload Bank Statement requested." });

        } else if (responseType === "upload_itr") {
            setShowTyping(true);
            setShowOverlay(true);
            await delay(1000);
            setShowTyping(false);
            setCurrentStep("EDIT_ITR_UPLOAD");
            addChatMessage({ text: "Re-upload ITR Statement requested." });

        } else if (responseType === "upload_gst") {
            setShowTyping(true);
            setShowOverlay(true);
            await delay(1000);
            setShowTyping(false);
            setCurrentStep("EDIT_GST_UPLOAD");
            addChatMessage({ text: "Re-upload GST certificate requested." });

        } else if (responseType === "upload_cmp_pan") {
            setShowTyping(true);
            setShowOverlay(true);
            await delay(1000);
            setShowTyping(false);
            setCurrentStep("EDIT_CMP_PAN_UPLOAD");
            addChatMessage({ text: "Re-upload Company PAN card document requested." });

        } else if (responseType === "GST") {
            setShowTyping(true);
            await delay(100);
            setShowOverlay(true);
            setCurrentStep("EDIT_GST"); // Open GST Edit
            await delay(300);
            setShowTyping(false);
            addChatMessage({ text: "Updating GST Number... ⏳" });

        } else if (responseType === "COMP_PAN") {
            setShowTyping(true);
            await delay(100);
            setShowOverlay(true);
            setCurrentStep("EDIT_COMP_PAN"); // Open GST Edit
            await delay(300);
            setShowTyping(false);
            addChatMessage({ text: "Updating Company PAN Number... ⏳" });

        } else if (responseType === "loan_amount") {
            setCurrentStep("EDIT_LOAN_AMOUNT"); // ✅ Open Loan Amount Edit
        }
    };

    const handlesteps = async () => {
        const newStep = useChatStore.getState().currentStep
        if (newStep === "AADHAR_START") {
            if (!aadharNumber) {
                addChatMessage({ text: "Enter your Aadhar number" });
            } else {
                addChatMessage({
                    text: "Upload a copy of your Aadhar card.",
                    responseType: "upload_request"
                }, "bot");
            }
        }
        if (newStep === "BANK_UPLOAD") {
            addChatMessage({
                text: "Upload a copy of your Bank Statement.",
                responseType: "upload_request"
            }, "bot");
        }
        if (newStep === "ITR_UPLOAD") {
            addChatMessage({
                text: "Upload a copy of your ITR Statement.",
                responseType: "upload_request"
            }, "bot");
        }
        if (newStep === "COMPNAY_PAN_START") {
            if (!companypanNumber) {
                addChatMessage({ text: "Enter your Company PAN number" });
            } else {
                addChatMessage({
                    text: "Upload a copy of your Company PAN card.",
                    responseType: "upload_request"
                }, "bot");
            }
        }

        if (newStep === "KYC_START") {
            if (!panNumber) {
                addChatMessage({ text: "Enter your PAN card number" });
            } else {
                addChatMessage({
                    text: "Upload a copy of your PAN card.",
                    responseType: "upload_request"
                }, "bot");
            }
        }
        if (newStep === "COMPANY_GST_START") {
            if (!gstNumber && !isGstUpload) {
                addChatMessage({ text: "Enter company's GST number" });
            } else {
                addChatMessage({
                    text: "Upload a copy of company GST",
                    responseType: "upload_request"
                }, "bot");
            }
        }

    }

    const handlePanUpdate = async (newPan) => {
        addChatMessage({ text: `New PAN Number: ${newPan}` }, "user");
        setShowTyping(true);
        await delay(1000);
        try {
            // ✅ Save New PAN to Database
            await axios.put(`${CREDIT_API_URL}kyc-documents/pan/${loanId}`, {
                customerId: customer.customerId,
                documentType: "PAN",
                panNumber: newPan,
            });
            addChatMessage({ text: "PAN Number updated successfully! ✅" });
            setPanNumber(newPan);
            setShowTyping(false);
            setShowOverlay(false);
            if (!isPanUploaded && !isPanCompleted) {
                await delay(1000);
                addChatMessage({
                    text: "Upload a copy of your PAN card.",
                    responseType: "upload_request"
                }, "bot");
                setCurrentStep("KYC_START");
            } else {
                await fetchChatHistory(chatSessionId);
                await handlesteps();
            }
        } catch (error) {
            console.error("❌ Failed to update PAN:", error);
            addChatMessage({ text: "❌ Error updating PAN. Please try again." });
        }
    };

    const handleEditPanUpload = async (fileName, file) => {
        setShowTyping(true);
        // ✅ Send PAN Number & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "PAN");
        formData.append("panNumber", panNumber);
        formData.append("document", file); // ✅ Upload file as multipart
        await delay(1000);
        try {
            await axios.post(`${CREDIT_API_URL}kyc-documents/pan-file/${loanId}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setShowTyping(false);
            setShowOverlay(false);
            addChatMessage({ text: `Updated PAN card`, responseType: "upload", attachmentPath: fileName }, "user");
            addChatMessage({ text: `New PAN card document updated successfully! ✅`, responseType: "normal" }, "bot");
            console.log("✅ PAN KYC submitted successfully!");
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    const handleAadharUpdate = async (newAadhar) => {
        addChatMessage({ text: `New Aadhar Number: ${newAadhar}` }, "user");
        setShowTyping(true);
        await delay(1000);
        try {
            // ✅ Save New Aadhar to Database
            await axios.put(`${CREDIT_API_URL}kyc-documents/aadhar/${loanId}`, {
                customerId: customer.customerId,
                documentType: "Aadhar",
                aadharNumber: newAadhar,
            });
            addChatMessage({ text: "Aadhar Number updated successfully! ✅" });
            setAadharNumber(newAadhar);
            setShowTyping(false);
            setShowOverlay(false);
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Failed to update Aadhar:", error);
            addChatMessage({ text: "❌ Error updating Aadhar. Please try again." });
        }
    };

    const handleEditAadharUpload = async (fileName, file) => {
        setShowTyping(true);
        // ✅ Send PAN Number & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "Aadhar");
        formData.append("aadharNumber", aadharNumber);
        formData.append("document", file); // ✅ Upload file as multipart
        await delay(1000);
        try {
            await axios.post(`${CREDIT_API_URL}kyc-documents/aadhar-file/${loanId}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setShowTyping(false);
            addChatMessage({ text: `Updated Aadhar card`, responseType: "upload", attachmentPath: fileName }, "user");
            addChatMessage({ text: `New Aadhar card document updated successfully! ✅`, responseType: "normal" }, "bot");
            setShowOverlay(false);
            console.log("✅ Aadhar KYC submitted successfully!");
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    const handleEditBankUpload = async (fileName, file) => {
        setShowTyping(true);
        // ✅ Send Bank Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "BankStatement");
        formData.append("document", file); // ✅ Upload file as multipart
        try {
            await axios.post(`${CREDIT_API_URL}kyc-documents/generaldoc-file/${loanId}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            await delay(500);
            setShowTyping(false);
            addChatMessage({ text: `Updated Bank statement`, responseType: "upload", attachmentPath: fileName }, "user");
            await delay(500);
            addChatMessage({ text: `New Bank statement document updated successfully! ✅`, responseType: "normal" }, "bot");
            setShowOverlay(false);
            console.log("✅ Bank statement submitted successfully!");
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    const handleEditItrUpload = async (fileName, file) => {
        setShowTyping(true);
        // ✅ Send Bank Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "ITR");
        formData.append("document", file); // ✅ Upload file as multipart
        try {
            await axios.post(`${CREDIT_API_URL}kyc-documents/generaldoc-file/${loanId}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            await delay(500);
            setShowTyping(false);
            addChatMessage({ text: `Updated ITR statement`, responseType: "upload", attachmentPath: fileName }, "user");
            await delay(500);
            addChatMessage({ text: `New ITR statement document updated successfully! ✅`, responseType: "normal" }, "bot");
            console.log("✅ ITR statement submitted successfully!");
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    const handleApplicationEditTypeProceed = async (response) => {
        if (response === "Individual") {
            addChatMessage({ text: response, responseType: "selection" }, "user");
            setShowTyping(true);
            await delay(1000);
            addChatMessage({ text: "Updated Application Type: " + response });
            await delay(1000);
            await fetchChatHistory(chatSessionId);
            await delay(1000);
            setShowTyping(false);
            await handlesteps();
        } else if (response === "Company") {
            addChatMessage({ text: response, responseType: "selection" }, "user");
            addChatMessage({ text: "Updated Application Type: " + response });
            await delay(1000);
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        }
    };

    const handleGstNumbUpdate = async (newPan) => {
        addChatMessage({ text: `New GST Number: ${newPan}` }, "user");
        setShowTyping(true);
        try {
            // ✅ Save New PAN to Database
            await axios.put(`${CREDIT_API_URL}kyc-documents/general-type/${loanId}`, {
                customerId: customer.customerId,
                documentType: "GSTC",
                panNumber: newPan,
            });
            setGstNumber(newPan);
            setShowOverlay(false);
            addChatMessage({ text: "GST Number updated successfully! ✅" });
            setShowTyping(false);
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Failed to update GST:", error);
            addChatMessage({ text: "❌ Error updating GST. Please try again." });
        }
    };

    const handleEditGstUpload = async (fileName, file) => {
        setShowTyping(true);
        // ✅ Send PAN Number & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "GSTC");
        formData.append("documentValue", gstNumber);
        formData.append("document", file); // ✅ Upload file as multipart
        await delay(1000);
        try {
            await axios.post(`${CREDIT_API_URL}kyc-documents/general-docs-company/${loanId}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setShowTyping(false);
            addChatMessage({ text: `Updated GST certificate`, responseType: "upload", attachmentPath: fileName }, "user");
            addChatMessage({ text: `New GST certificate document updated successfully! ✅`, responseType: "normal" }, "bot");
            setShowOverlay(false);
            console.log("✅ GST certificate submitted successfully!");
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    const handleCompPanUpdate = async (newPan) => {
        addChatMessage({ text: `New Company PAN Number: ${newPan}` }, "user");
        setShowTyping(true);
        try {
            // ✅ Save New PAN to Database
            await axios.put(`${CREDIT_API_URL}kyc-documents/general-type/${loanId}`, {
                customerId: customer.customerId,
                documentType: "COMP_PAN",
                panNumber: newPan,
            });
            setCompanypanNumber(newPan);
            setShowOverlay(false);
            addChatMessage({ text: "Company PAN Number updated successfully! ✅" });
            setShowTyping(false);
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Failed to update GST:", error);
            addChatMessage({ text: "❌ Error updating GST. Please try again." });
        }
    };

    const handleEditCompPanUpload = async (fileName, file) => {
        setShowTyping(true);
        // ✅ Send PAN Number & Document to API
        const formData = new FormData();
        formData.append("customerId", customer.customerId);
        formData.append("documentType", "COMP_PAN");
        formData.append("documentValue", companypanNumber);
        formData.append("document", file); // ✅ Upload file as multipart
        await delay(1000);
        try {
            await axios.post(`${CREDIT_API_URL}kyc-documents/general-docs-company/${loanId}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setShowTyping(false);
            setShowOverlay(false);
            addChatMessage({ text: `Updated Company PAN card`, responseType: "upload", attachmentPath: fileName }, "user");
            addChatMessage({ text: `New Company PAN card document updated successfully! ✅`, responseType: "normal" }, "bot");
            console.log("✅ Company PAN card certificate submitted successfully!");
            await fetchChatHistory(chatSessionId);
            await handlesteps();
        } catch (error) {
            console.error("❌ Error submitting PAN KYC:", error);
        }
    };

    const deleteDocument = async (documentType) => {
        if (!loanId) return console.error("❌ No loanId found!");
        try {
            await axios.delete(`${CREDIT_API_URL}kyc-documents/${loanId}`, {
                data: { documentType },
                headers: { "Content-Type": "application/json" },
            });
            console.log(`✅ ${documentType} document deleted successfully!`);
        } catch (error) {
            console.error(`❌ Failed to delete ${documentType} document:`, error);
        }
    };

    const closeChatSession = async (chatSessionId) => {
        if (!chatSessionId) {
            console.error("❌ Chat Session ID is missing, cannot close session.");
            return;
        }

        try {
            await axios.put(`${CREDIT_API_URL}chat-sessions/${chatSessionId}`, {
                status: "Closed"
            });

            console.log(`✅ Chat Session ${chatSessionId} successfully closed.`);

        } catch (error) {
            console.error("❌ Error closing chat session:", error);
        }
    };
    return (
        <section className="chatbot-section">
            <div className="chatbot-section-container">
                <div className="left-chatbot-section">
                    <div className="left-chatbot-heading-section">
                        <div className="left-chatbot-heading-section-img">
                            <img alt="bizzie-icon" src="/images/chatbot-heading-icon.png" />
                        </div>
                        <div className="left-chatbot-heading-section-content">Bizzie</div>
                    </div>
                    <div className="left-chatbot-chat-section" ref={chatContainerRef}>
                        {showOverlay && <div className="chat-overlay"></div>}
                        {/* ✅ Display Past Chat History */}
                        {chatHistory.map((chat, index) => (
                            (chat.responseType === "upload_request") ? (
                                <DocumentUploadQuestion key={index} DocumentQuestion={chat.messageText} />
                            ) : (chat.responseType === "upload" || chat.responseType === "upload_pan" || chat.responseType === "upload_aadhar"
                                || chat.responseType === "upload_bank" || chat.responseType === "upload_itr" || chat.responseType === "upload_gst"
                                || chat.responseType === "upload_cmp_pan") ? (
                                <UserUploadResponse
                                    key={index}
                                    UploadResponse={chat.messageText}
                                    responseType={chat.responseType} // e.g., "upload_pan"
                                    attachmentName={chat.attachmentPath}
                                    onEdit={() => handleEditResponse(chat.responseType)}
                                />
                            ) : (chat.sentBy === "user") ? (
                                <UserTypedResponse key={index} TypedResponse={chat.messageText} responseType={chat.responseType} onEdit={() => handleEditResponse(chat.responseType)} />
                            ) : (
                                <NormalQuestion key={index} NormalQuestion={chat.messageText} />
                            )
                        ))}
{/* <OptionTypeWithTitleResponse Question="Why do you need loan?" options={['commercial vehicle loan','Two wheeler loan','Business loan','Inventory / Supply chain financing','commercial Equipment financing']}/> */}
                        {/* ✅ Welcome Message
                        {currentStep === "WELCOME" && !loanId && (
                            <NormalQuestion NormalQuestion="Hey there! 👋 I'm Bizzie, your loan buddy!" />
                        )} */}

                        {/* ✅ Show Mobile Number Input Before Anything Else */}
                        {currentStep === "MOBILE_CONFIRM" && (
                            <TypedResponse Question="Confirm your OTP" onResponse={handleOtpConfirmation} documentType="OTP" />
                        )}

                        {/* ✅ OTP Modal
                        {showOtpModal && <OtpModal onClose={() => setShowOtpModal(false)} onConfirm={confirmOtp} />} */}

                        {/* ✅ Show Loan Amount Input */}
                        {currentStep === "LOAN_AMOUNT" && (
                            <TypedResponse Question="Enter the new loan amount" onResponse={handleLoanAmountChange} />
                        )}

                        {/* ✅ Show Lead Details if Available */}
                        {/* {leadDetails && currentStep === "WELCOME" && !loanId && ( */}
                            {/* <>
                                <NormalQuestion NormalQuestion={`You have applied for ₹${leadDetails.loanAmount} under ${leadDetails.productType}.`} /> */}
                                {/* <OptionTypeResponse
                                    Question="Would you like to proceed?"
                                    options={["Yes", "No"]}
                                    onSelect={(option) => handleProceed(option)}
                                /> */}
                            {/* </>
                        )} */}

                        {/* ❌ If No Commercial Loan Exists */}
                        {currentStep === "NOT_ELIGIBLE" && (
                            <NormalQuestion NormalQuestion="Currently, we only process Commercial Vehicle Loans." />
                        )}

                        {/* ✅ Ask "Individual or Company?" After Mobile Confirmation */}
                        {currentStep === "APPLICANT_TYPE" && (
                            <OptionTypeResponse
                                Question="Do you want to apply as an 'Individual' or 'Company'?"
                                options={["Individual", "Company"]}
                                onSelect={(option) => handleApplicationTypeProceed(option)}
                            />
                        )}

                        {currentStep === "APPLICANT_TYPE_EDIT" && (
                            <OptionTypeResponse
                                Question="Do you want to apply as an 'Individual' or 'Company'?"
                                options={["Individual", "Company"]}
                                onSelect={(option) => handleApplicationEditTypeProceed(option)}
                            />
                        )}

                        {/* ✅ Show PAN Number Input Only If Not Already Filled or not explicitly provided by user */}
                        {currentStep === "KYC_START" && !isPanCompleted && (!panNumber || !lastUserPanSubmission) && (
                            <TypedResponse Question="PAN number" onResponse={handlePanNumber} documentType="PAN" isEdit={false} />
                        )}

                        {/* 🔥 Simulate Bot Thinking */}
                        {showTyping && <TypingIndicator />}


                        {/* ✅ Show PAN Upload Only If Number is Entered & Not Already Uploaded */}
                        {currentStep === "KYC_START" && panNumber && !isPanUploaded && !isPanCompleted && lastUserPanSubmission && (
                            // Only show upload if PAN looks valid and user has submitted it in this session
                            (/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(String(panNumber).trim())) ? (
                                <UploadMessage Question="Upload document" onUpload={handlePanUpload} chatContainerRef={chatContainerRef} isEdit={false} />
                            ) : null
                        )}

                        {currentStep === "EDIT_PAN" && (
                            <TypedResponse
                                Question="New PAN number"
                                documentType="PAN"
                                onResponse={handlePanUpdate}
                                isEdit={true}
                            />
                        )}

                        {currentStep === "EDIT_PAN_UPLOAD" && (
                            <UploadMessage
                                Question="Re-upload PAN document"
                                documentType="PAN"
                                onUpload={handleEditPanUpload}
                                chatContainerRef={chatContainerRef}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Show Aadhar Number Input First */}
                        {currentStep === "AADHAR_START" && kycType === "Individual" && !aadharNumber && !isAadharUploaded && (
                            <TypedResponse Question="Aadhar number" onResponse={handleAadharNumber} documentType="Aadhar" isEdit={false} />
                        )}

                        {/* ✅ Show Aadhar Upload Only If Number is Entered & Not Already Uploaded */}
                        {currentStep === "AADHAR_START" && kycType === "Individual" && aadharNumber && !isAadharUploaded && lastUserAadharSubmission && (
                            // Ensure Aadhar is 12 digits before prompting upload and user submitted it
                            (/^\d{12}$/.test(String(aadharNumber).trim())) ? (
                                <UploadMessage Question="Upload document" onUpload={handleAadharUpload} chatContainerRef={chatContainerRef} isEdit={false} />
                            ) : null
                        )}

                        {currentStep === "EDIT_Aadhar" && (
                            <TypedResponse
                                Question="New Aadhar number"
                                documentType="Aadhar"
                                onResponse={handleAadharUpdate}
                                isEdit={true}
                            />
                        )}

                        {currentStep === "EDIT_Aadhar_UPLOAD" && (
                            <UploadMessage
                                Question="Re-upload Aadhar document"
                                documentType="Aadhar"
                                onUpload={handleEditAadharUpload}
                                chatContainerRef={chatContainerRef}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Show Aadhar Number Input First */}
                        {currentStep === "COMPANY_GST_START" && kycType === "Company" && !gstNumber && !isGstUpload && (
                            <TypedResponse Question="GST number" onResponse={handleCompanyGstNumber} documentType="GST" isEdit={false} />
                        )}

                        {currentStep === "EDIT_GST" && (
                            <TypedResponse
                                Question="Updating GST Number..."
                                documentType="GST"
                                onResponse={handleGstNumbUpdate}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Show Aadhar Upload Only If Number is Entered & Not Already Uploaded */}
                        {currentStep === "COMPANY_GST_START" && kycType === "Company" && gstNumber && !isGstUpload && (
                            <UploadMessage Question="Upload document" onUpload={handleCompanyGstUpload} chatContainerRef={chatContainerRef} isEdit={false} />
                        )}

                        {currentStep === "EDIT_GST_UPLOAD" && (
                            <UploadMessage
                                Question="Re-upload GST document"
                                documentType="GST"
                                onUpload={handleEditGstUpload}
                                chatContainerRef={chatContainerRef}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Show PAN Number Input Only If Not Already Filled */}
                        {currentStep === "COMPNAY_PAN_START" && !companypanNumber && (
                            <TypedResponse Question="PAN card number." onResponse={handleCompanyPanNumber} documentType="CPAN" isEdit={false} />
                        )}

                        {currentStep === "EDIT_COMP_PAN" && (
                            <TypedResponse
                                Question="Updating Pan card Number..."
                                documentType="COMP_PAN"
                                onResponse={handleCompPanUpdate}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Show PAN Upload Only If Number is Entered & Not Already Uploaded */}
                        {currentStep === "COMPNAY_PAN_START" && companypanNumber && !isCompanyPanUploaded && (
                            <UploadMessage Question="Upload document" onUpload={handleCompanyPanUpload} chatContainerRef={chatContainerRef} isEdit={false} />
                        )}

                        {currentStep === "EDIT_CMP_PAN_UPLOAD" && (
                            <UploadMessage
                                Question="Re-upload PAN document"
                                documentType="COMP_PAN"
                                onUpload={handleEditCompPanUpload}
                                chatContainerRef={chatContainerRef}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Show Bank Statement Upload */}
                        {currentStep === "BANK_UPLOAD" && !isBankUploaded && (
                            <UploadMessage Question="Upload document" onUpload={handleBankUpload} chatContainerRef={chatContainerRef} isEdit={false} />
                        )}

                        {currentStep === "EDIT_BANK_UPLOAD" && (
                            <UploadMessage
                                Question="Re-upload Bank Statement"
                                documentType="Bank"
                                onUpload={handleEditBankUpload}
                                chatContainerRef={chatContainerRef}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Show ITR Upload */}
                        {currentStep === "ITR_UPLOAD" && !isItrUploaded && (
                            <UploadMultiMessage Question="Upload last 3 years ITR statement." onUpload={handleItrUpload} chatContainerRef={chatContainerRef} isEdit={false} />
                        )}

                        {currentStep === "EDIT_ITR_UPLOAD" && (
                            <UploadMessage
                                Question="Re-upload ITR document"
                                documentType="ITR"
                                onUpload={handleEditItrUpload}
                                chatContainerRef={chatContainerRef}
                                isEdit={true}
                            />
                        )}

                        {/* ✅ Final Thank You Message */}
                        {currentStep === "THANK_YOU" && (
                            <NormalQuestion NormalQuestion="Thank you! 🙌 Your loan application is complete." />
                        )}
                        {/* ✅ Final Thank You Message */}
                        {currentStep === "THANK_YOU" && (
                            <NormalQuestion NormalQuestion="Our team will review your details and get back to you soon! 🎉" />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ChatSection;
